export default {
  common: {
    nav: {
      home: "হোম",
      find_offer_help: "সাহায্য খুঁজুন / দিন",
      celebrate: "জীবন উদযাপন",
      family_tree: "পরিবার বৃক্ষ",
      events: "ইভেন্ট",
      civic_reports: "নাগরিক প্রতিবেদন",
      neighborhood_pulse: "পাড়ার স্পন্দন",
      weather: "আবহাওয়া",
      nature: "প্রকৃতি",
      marketplace: "বাজার",
      news: "সংবাদ",
      causes: "উদ্দেশ্য",
      more: "আরো",
    },
    header: { sign_in: "সাইন ইন", join: "Social Pulse-এ যোগ দিন", language: "ভাষা", search: "অনুসন্ধান" },
    tagline: "সম্প্রদায়কে সংযুক্ত করা · জীবনকে ক্ষমতায়ন · সামাজিক পুঁজি গঠন",
    locality: {
      viewing_from: "আপনি দেখছেন",
      help_improve: "আপনার অবস্থান উন্নত করতে সাহায্য করুন",
      filter_by_country: "দেশ অনুযায়ী ফিল্টার",
      change: "পরিবর্তন",
      set_your_location: "আপনার অবস্থান সেট করুন",
      set_your_location_hint: "— ব্যক্তিগতকৃত করতে ট্যাপ করুন",
    },
    actions: {
      submit_cause: "একটি উদ্দেশ্য / আবেদন জমা দিন",
      make_donation: "Social Pulse-এর বৈশ্বিক উদ্যোগকে সমর্থন করুন — অনুদান দিন",
      browse_all: "সমস্ত বিভাগ ব্রাউজ করুন",
    },
    news: {
      title: "আপনার দৈনিক ব্রিফিং।",
      submit_news: "সংবাদ পাঠান",
      archive: "সংরক্ষণাগার",
      weather_nature: "আবহাওয়া ও প্রকৃতি",
      play_briefing: "দৈনিক ব্রিফিং শুনুন",
      play_briefing_hint: "শীর্ষ {{count}}টি সংবাদ শুনুন · ~{{minutes}} মিনিট · আপনার ভাষায়",
      read_original: "মূল পড়ুন",
      view_brief: "সংক্ষিপ্ত দেখুন",
      also_reported_by: "এদের দ্বারাও রিপোর্ট:",
      translate: "অনুবাদ করুন",
      listen: "শুনুন",
      stop: "থামুন",
    },
  },
};
